import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { MarketPrice, Preloader } from '../../components/MarketPrice';
import { selectEstimationByDealType } from '../../selectors/estimation';
import { selectDealType, selectIsMyHome } from '../../selectors/page';
import { useFirstScrollControl } from './utils';
import { getReportState } from '../../selectors/report';
import { EReportStatus } from '../../constants/report';
import { defaultRefWrapper, TRefWrapper } from '../Scrolling';
import { PreciseFiltersContainer } from '../PreciseFiltersContainer';
import { PriceAverageContainer } from '../PriceAverageContainer';

interface IMarketPriceContainerProps {
  refWrapper?: TRefWrapper;
}

export function MarketPriceContainer({ refWrapper = defaultRefWrapper }: IMarketPriceContainerProps): React.JSX.Element | null {
  const isDesktop = useIsDesktop();
  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));
  const { reportStatus } = useSelector(getReportState);
  const isMyHome = useSelector(selectIsMyHome);

  useFirstScrollControl();

  if (estimation.isFetching === undefined) {
    return null;
  }

  if (!estimation.data && estimation.isFetching) {
    return <Preloader />;
  }

  return refWrapper(
    <MarketPrice
      isReportResultDescriptionVisible={reportStatus !== EReportStatus.Default && !isDesktop}
      isDesktop={isDesktop}
      isFetching={estimation.isFetching}
      preciseFilters={!isMyHome ? <PreciseFiltersContainer /> : null}
      priceAverage={<PriceAverageContainer />}
    />,
  );
}
